import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import logo from "../../assets/images/logo-ps1.png";

class PagesComingsoon extends Component {
    constructor() {
        super();
        this.renderer.bind(this)
    }

    renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <span>You are good to go!</span>;
        } else {
            // Render a countdown
            return <>
            <div className="coming-box">{days} <span>Days</span></div> <div className="coming-box">{hours} <span>Hours</span></div> <div className="coming-box">{minutes} <span>Minutes</span></div> <div className="coming-box">{seconds} <span>Seconds</span></div>
            </>
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="home-btn d-none d-sm-block">
                    <Link to="/" className="text-white"><i className="fas fa-home h2"></i></Link>
                </div>

                <div className="my-5 pt-sm-5">
                    <Container>
                        <Row>
                            <Col lg="12">
                                <div className="text-center">
                                    <Link to="/">
                                        <img src={logo} alt="logo" height="75" />
                                    </Link>
                                    {/* <Row className="justify-content-center mt-5">
                                        <Col sm="4">
                                            <div className="maintenance-img">
                                                <img src={maintenance} alt="" className="img-fluid mx-auto d-block" />
                                            </div>
                                        </Col>
                                    </Row> */}
                                    <h4 className="mt-5">Kjo faqe është duke u ndërtuar.</h4>
                                    <p className="text-muted">Ju lutemi kontrolloni më vonë.</p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default PagesComingsoon;
